import _Vue from 'vue';
import Keycloak, { KeycloakConfig } from 'keycloak-js';
import { check_user_internal } from '@/utils';
import { KeyCloak } from './types';

const keycloak_urls: Record<string, string> = {
  int: window.env.VUE_APP_KEYCLOAK_INTERNAL_URL,
  ext: window.env.VUE_APP_KEYCLOAK_EXTERNAL_URL,
};

const keycloak_realms: Record<string, string> = {
  int: window.env.VUE_APP_KEYCLOAK_REALM_INT,
  ext: window.env.VUE_APP_KEYCLOAK_REALM_EXT,
};

const internal_user_param = window.env.VUE_APP_KEYCLOAK_USER_TYPE_PARAM;

// проверка адреса домена на наличие ключевого слова для определения типа пользователя; зафиксировано слово 'internal'
const is_internal = check_user_internal(internal_user_param);

const initOptions: KeycloakConfig = {
  url: is_internal ? keycloak_urls.int : keycloak_urls.ext,
  realm: is_internal ? keycloak_realms.int : keycloak_realms.ext,
  clientId: window.env.VUE_APP_KEYCLOAK_CLIENT_ID ?? KeyCloak.KeyCloakClients.AS_FRONTEND,
};

const keycloak = new Keycloak(initOptions);
const user_type: KeyCloak.User = is_internal
  ? KeyCloak.UserTypes.INTERNAL
  : KeyCloak.UserTypes.EXTERNAL;

localStorage.setItem(KeyCloak.TokenPrefix.USER_TYPE, user_type);

const keycloak_plugin = {
  install(vue: typeof _Vue) {
    const Vue = vue;

    Vue.prototype.$user_type = user_type;
    Vue.user_type = user_type;

    Vue.prototype.$keycloak_instance = keycloak;
    Vue.keycloak_instance = keycloak;
  },
};

export { keycloak_plugin };
